//TODO turn into regular json files

export interface Translations {
	[key: string]: TranslationObject;
}

export interface TranslationObject {
	settingsTooltip: string;
	noMessages: string;
	todayLabel: string;
	yesterdayLabel: string;
	olderLabel: string;
	genericError: string;
	ttlTooltip: string;
}

export const translations: Translations = {
	de: {
		settingsTooltip: "Benachrichtigungseinstellungen",
		noMessages: "Es liegen derzeit keine Nachrichten für Sie vor.",
		todayLabel: "Heute",
		yesterdayLabel: "Gestern",
		olderLabel: "Älter",
		genericError: "Ein Fehler ist aufgetreten. Versuchen Sie es später bitte erneut.",
		ttlTooltip: "Die Benachrichtigung wird nach der angezeigten Zeit automatisch gelöscht",
	},
	zh: {
		settingsTooltip: "通知设置",
		noMessages: "目前没有给您的新信息提示。",
		todayLabel: "今天",
		yesterdayLabel: "昨天",
		olderLabel: "更早",
		genericError: "发生了一个错误。请稍后再试。",
		ttlTooltip: "显示的时间过后，通知会自动删除",
	},
	en: {
		settingsTooltip: "Notification Settings",
		noMessages: "There are currently no messages for you.",
		todayLabel: "Today",
		yesterdayLabel: "Yesterday",
		olderLabel: "Older",
		genericError: "An error has occurred. Please try again later.",
		ttlTooltip: "The notification is automatically deleted after the time indicated",
	},
	fr: {
		settingsTooltip: "Paramètres de notification",
		noMessages: "Vous n'avez actuellement aucun message.",
		todayLabel: "Aujourd'hui",
		yesterdayLabel: "Hier",
		olderLabel: "Date plus ancienne",
		genericError: "Une erreur s'est produite. Veuillez réessayer plus tard.",
		ttlTooltip: "La notification est supprimée automatiquement après expiration du délai indiqué.",
	},
	it: {
		settingsTooltip: "Impostazioni di notifica",
		noMessages: "Al momento non ci sono messaggi.",
		todayLabel: "Oggi",
		yesterdayLabel: "Ieri",
		olderLabel: "Precedenti",
		genericError: "Si è verificato un errore. Per favore riprova più tardi.",
		ttlTooltip: "La notifica viene eliminata automaticamente dopo il tempo indicato",
	},
	ko: {
		settingsTooltip: "알림 설정",
		noMessages: "현재 새 메시지가 없습니다.",
		todayLabel: "오늘",
		yesterdayLabel: "어제",
		olderLabel: "이전",
		genericError: "오류가 발생했습니다. 나중에 다시 시도해 주세요.",
		ttlTooltip: "알림은 표시된 시간이 지나면 자동으로 삭제됩니다",
	},
	nl: {
		settingsTooltip: "Meldingsinstellingen",
		noMessages: "Er zijn momenteel voor u geen meldingen.",
		todayLabel: "Vandaag",
		yesterdayLabel: "Gisteren",
		olderLabel: "Ouder",
		genericError: "Er is een fout opgetreden. Probeer het later opnieuw.",
		ttlTooltip: "Het bericht wordt na de weergegeven tijd automatisch gewist",
	},
	pl: {
		settingsTooltip: "Ustawienia powiadomień",
		noMessages: "Obecnie nie mają Państwo żadnych wiadomości.",
		todayLabel: "Dzisiaj",
		yesterdayLabel: "Wczoraj",
		olderLabel: "Starsze",
		genericError: "Wystąpił błąd. Proszę spróbować ponownie później.",
		ttlTooltip: "Powiadomienie zostanie automatycznie usunięte po upływie wskazanego czasu",
	},
	es: {
		settingsTooltip: "Configuración de notificaciones",
		noMessages: "Actualmente no hay mensajes nuevos para ti.",
		todayLabel: "Hoy",
		yesterdayLabel: "Ayer",
		olderLabel: "Anteriores",
		genericError: "Ha ocurrido un error. Por favor, inténtelo de nuevo más tarde.",
		ttlTooltip: "La notificación se borrará automáticamente una vez transcurrido el tiempo estipulado",
	},
	cs: {
		settingsTooltip: "Nastavení oznámení",
		noMessages: "Nyní pro Vás nejsou k dispozici žádná nová hlášení.",
		todayLabel: "Dnes",
		yesterdayLabel: "Včera",
		olderLabel: "Starší",
		genericError: "Došlo k chybě. Zkuste to prosím znovu později.",
		ttlTooltip: "Zpráva bude po zobrazené době automaticky vymazána.",
	},
	hu: {
		settingsTooltip: "Értesítési beállítások",
		noMessages: "Jelenleg Önnek nincsenek új üzenetei.",
		todayLabel: "Ma",
		yesterdayLabel: "Tegnap",
		olderLabel: "Régebbi",
		genericError: "Hiba történt. Kérjük, próbálja meg később újra.",
		ttlTooltip: "Az értesítés a kijelzett idő elteltével törlődik",
	},
	zh_TW: {
		settingsTooltip: "通知設定",
		noMessages: "目前沒有給您的訊息。",
		todayLabel: "現在",
		yesterdayLabel: "昨天",
		olderLabel: "更早",
		genericError: "發生了錯誤。請稍後再試。",
		ttlTooltip: "訊息會在顯示時間後自動刪除",
	},
	ja: {
		settingsTooltip: "通知設定",
		noMessages: "現在、お客様宛の通知はありません。",
		todayLabel: "今日",
		yesterdayLabel: "昨日",
		olderLabel: "それ以前",
		genericError: "エラーが発生しました。後でもう一度お試しください。",
		ttlTooltip: "通知は、表示時間後に自動的に削除されます。",
	},
	pt: {
		settingsTooltip: "Definições de notificação",
		noMessages: "De momento não existem avisos para si.",
		todayLabel: "Hoje",
		yesterdayLabel: "Ontem",
		olderLabel: "Mais antigo",
		genericError: "Ocorreu um erro. Por favor, tente novamente mais tarde.",
		ttlTooltip: "A notificação é eliminada automaticamente após o tempo indicado",
	},
};
